type HasPermissionFn = (role: string) => boolean;

/**
 * Roles que liberam o módulo TOI. Usada também em `toi.routes.ts` e no menu
 * lateral — manter os três pontos sincronizados por esta constante.
 */
export const TOI_CONSULTA_ROLES = [
  'MXL_ATIVIDADE_TOI_CON',
  'Admin',
] as const;

export const TOI_EDICAO_ROLES = [
  'MXL_ATIVIDADE_TOI_EDT',
  'Admin',
] as const;

/** Consulta: acesso à tela e visualização do TOI. */
export function usuarioPodeConsultarToi(hasPermission: HasPermissionFn): boolean {
  return TOI_CONSULTA_ROLES.some((role) => hasPermission(role));
}

/** Edição: ações de alteração do TOI (validar, corrigir endereço, salvar detalhe). */
export function usuarioPodeEditarToi(hasPermission: HasPermissionFn): boolean {
  return TOI_EDICAO_ROLES.some((role) => hasPermission(role));
}
